module.exports = __webpack_public_path__ + "img/stats.0d12c30e.svg";